import { GlobalStyles as MUIGlobalStyles, useTheme } from "@mui/material";
import React from "react";

const GlobalStyles = (): JSX.Element => {
  const theme = useTheme();

  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        "*": { margin: 0, padding: 0, boxSizing: "border-box" },
        html: { width: "100%", height: "100%", msTextSizeAdjust: "100%", webkitOverflowScrolling: "touch" },
        body: { width: "100%", height: "100%" },
        "#root": { width: "100%", height: "100%" },
        div: {
          "&::-webkit-scrollbar": { width: theme.spacing(1.5) },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
            height: theme.spacing(1),
            borderRadius: theme.shape.borderRadius,
          },
          "&::-webkit-scrollbar-thumb": {
            background: theme.palette.secondary.main,
            borderRadius: theme.shape.borderRadius,
            border: "4px solid transparent",
            backgroundClip: "padding-box",
          },
        },
        input: {
          "&[type=number]": {
            mozAppearance: "textfield",
            "&::-webkit-outer-spin-button": { margin: 0, webkitAppearance: "none" },
            "&::-webkit-inner-spin-button": { margin: 0, webkitAppearance: "none" },
          },
        },
        textarea: {
          "&::-webkit-input-placeholder": { color: theme.palette.text.disabled },
          "&::-moz-placeholder": { opacity: 1, color: theme.palette.text.disabled },
          "&:-ms-input-placeholder": { color: theme.palette.text.disabled },
          "&::placeholder": { color: theme.palette.text.disabled },
        },
        a: { color: theme.palette.primary.main },
        img: { display: "block", maxWidth: "100%" },
        ul: { margin: 0, padding: 0 },

        // Lazy Load Img
        ".blur-up": {
          webkitFilter: "blur(5px)",
          filter: "blur(5px)",
          transition: "filter 400ms, -webkit-filter 400ms",
        },
        ".blur-up.lazyloaded ": { webkitFilter: "blur(0)", filter: "blur(0)" },
      }}
    />
  );

  return inputGlobalStyles;
};

export default GlobalStyles;
